import moment from "moment";
import React, { useState } from "react";
import submit from "submit-form";
import Modal from "../../modal-new";

export const RemovePhaseDescriptionModal = ({
  athleteId,
  dateAttachment,
  phaseDescription,
  organizationCoachId,
}) => {
  const handleRemoveDescription = () => {
    let body = {
      dateAttachment: moment(dateAttachment, "MMM D, YYYY").format("YYYYMMDD"),
      athleteId,
    };
    if (organizationCoachId) {
      body = { ...body, organizationCoachId };
    }

    submit("/actions/annual-planner/remove-athlete-phase-description", {
      method: "POST",
      body,
    });
  };

  const goBackToDescription = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]": "phase-description",
        dateAttachment,
        athleteId,
      },
    });
  };

  return (
    <Modal
      className="annual-planner-modal remove-phase-description-modal"
      title={"Remove Phase Description"}
    >
      <div className="body">
        <span className="chip warning">
          You are about to remove the following phase description from your
          athlete. Please confirm.
        </span>
        <div className="remove-phase-description-modal-info">
          <div role="wrapper" className="phase-description-date">
            <label>Date</label>
            <label>{dateAttachment}</label>
          </div>

          <div role="wrapper" className="phase-description">
            <label>Description</label>
            <span className="phase-description">{phaseDescription}</span>
          </div>
        </div>
      </div>
      <footer className="remove">
        <button
          type="button"
          onClick={handleRemoveDescription}
          role="button"
          data-action="delete"
        >
          <img src="/img/new-icons/red-trash.svg" />
          Delete
        </button>
        <button
          type="button"
          onClick={goBackToDescription}
          role="button"
          data-action="cancel"
          data-button-type="tertiary"
        >
          Cancel
        </button>
      </footer>
    </Modal>
  );
};
